<div class="container"
    style="text-align: justify; background: transparent !important; margin-bottom: 18%; margin-top: -20px; height: 220px;">
    <div class="row row-class" align="center">
        <div class="col-12" align="center">
            <h6 class="text-center" style="color: #6f706e !important; font-size: 20px;">Dietary preferences</h6>
            <ng-container *ngFor="let item of user_details.userDietary; index as i">
                <button class="buttonsdietary" [title]="item.diet_preference_name" [style.background-color]="'#47941b'"
                    [style.color]="'white'">
                    <span>{{item.diet_preference_name}}</span> </button>&nbsp;&nbsp;
            </ng-container>
        </div>
    </div>
</div>
<style>
    @media only screen and (min-width: 600px) {
        .container {
            width: 424px;
            max-width: 100%;
        }
    }

    .container {
        position: relative;
        margin-left: auto;
        margin-right: auto;
        padding-right: 11px;
        padding-left: 11px;
        margin-top: -15px;
    }

    .container p {
        font-size: 13px;
        margin-top: -10px;
    }

    ::ng-deep.mat-bottom-sheet-container {

        min-width: 100vw;
        box-sizing: border-box;
        display: block;
        outline: 0;
        max-height: 30vh;
        overflow: auto;
        /* background: transparent !important; */

    }

    .buttonsallergy {
        border-radius: 10px;
        height: auto;
        width: auto;
        background-color: white;
        color: black;
        width: 30%;
        border: none;
        margin-bottom: 5px;
        margin-top: 5px;
        /* white-space: pre; */
        padding: 2px;
        padding: 4px;
    }

    .buttonsgen {
        border-radius: 10px;
        height: auto;
        width: auto;
        background-color: white;
        color: black;
        border: none;
        width: 150px;
        /* white-space: pre; */
        padding: 2px;
        padding: 4px;
    }

    .buttonsdietary {
        border-radius: 10px;
        height: auto;
        width: auto;
        border: none;
        margin-top: 5px;
        margin-bottom: 5px;
        background-color: white;
        color: black;
        width: 30%;
        /* white-space: pre; */
        padding: 2px;
        padding: 4px;
    }
</style>